import axios from 'axios'

export function getCsrfToken(): string | undefined {
  // backend stránky Väčšinou majú <meta name="csrf-token"> alebo skrytý <input name="_token">
  const meta = document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null
  if (meta?.content) return meta.content
  const input = document.querySelector('input[name="_token"]') as HTMLInputElement | null
  if (input?.value) return input.value
  return undefined
}

export function apiBase(isEmbedded: boolean): string {
  return isEmbedded ? '/backend/icestudio/labelsimply' : '/api/designer'
}

export function apiClient(isEmbedded: boolean) {
  const instance = axios.create({
    baseURL: apiBase(isEmbedded),
    withCredentials: true,
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
  // prilep CSRF pre POSTy (ak existuje)
  instance.interceptors.request.use((config) => {
    if ((config.method || 'get').toLowerCase() !== 'get') {
      const token = getCsrfToken()
      if (token) {
        config.headers = config.headers || {}
        ;(config.headers as any)['X-CSRF-TOKEN'] = token
      }
    }
    return config
  })
  return instance
}
